module.exports = __webpack_public_path__ + "media/images/proof_providers/keybase-22af312ae5def3706736e6a014fdc761.png";